module.exports = __webpack_public_path__ + "horoscope-a7968202de2bb505b8f0.jpg";